<template>
	<div>
		<el-dialog :visible.sync="visible" width="400px" :before-close="beforeClose" title="活动规则">
			<div class="font-h6-regular yx-color-text-regular">
				<p>1、活动有效期（6.1-9.1）内通过商团协作邀请商家注册免费的“热度云友情版”到指定数量，可获得同版本免费增加一年使用时长的奖励；</p>
				<p class="mt-4"
					>2、以绑定的热度云友情版的不重复注册手机号为有效邀约数量，重复手机号仅算1个有效邀请：热度云用户的同一手机号可以注册多个热度云友情版或同一个热度云友情版可以绑定多个店铺的商团协作；</p
				>
				<p class="mt-4">3、无论热度云友情版用户是否为新注册用户，绑定后对发起绑定的团长算1个有效注册；</p>
				<p class="mt-4">4、邀请进度显示“已完成”后，请及时联系专属商务获得同版本免费增加一年使用时长的奖励；</p>
				<p class="mt-4">5、活动最终解释权归“超佣团”运营团队所有；</p>
			</div>
			<div slot="footer">
				<el-button @click="beforeClose">我知道了</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
		beforeClose() {
			this.visible = false;
		},
	},
};
</script>